import React from 'react'

import { Grid } from '@mui/material'
import { InputText, ButtonLoading, SelectInput, Loading } from '../../../Simple'
import SettingsHook from '../SettingsHook'

export default function EditDados() {
  const { inpsStt, loadStt, actionsSettings } = SettingsHook()

  return (
    <>
      {loadStt.alterDados ? (
        <div className='contain-loading'>
          <Loading text={'Atualizando seus dados...'} />
        </div>
      ) : (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <InputText
              type='text'
              label='Nome Completo'
              value={inpsStt.nome}
              placeholder='Nome Completo'
              autoComplete={'name'}
              onChange={e => {
                actionsSettings.handleInpsStt('nome', e.target.value)
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <InputText
              type='text'
              label='E-mail'
              value={inpsStt.email}
              disabled={true}
              onChange={e => {
                actionsSettings.handleInpsStt('email', e.target.value)
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <SelectInput
              label='País'
              value={inpsStt.pais}
              autoComplete={'country'}
              onChange={e => {
                actionsSettings.handleInpsStt('pais', e.target.value)
              }}
              options={[
                { value: '+55', label: 'Brasil (+55)' },
                { value: '+54', label: 'Argentina (+54)' },
                { value: '+598', label: 'Uruguai (+598)' },
                { value: '+595', label: 'Paraguai (+595)' },
                { value: '+591', label: 'Bolívia (+591)' },
                { value: '+51', label: 'Peru (+51)' },
                { value: '+57', label: 'Colômbia (+57)' },
                { value: '+58', label: 'Venezuela (+58)' },
              ]}
            />
          </Grid>
          <Grid item xs={8}>
            <InputText
              type='text'
              label='Telefone'
              placeholder='Telefone'
              autoComplete={'tel'}
              value={inpsStt.telefone}
              onChange={e => {
                actionsSettings.handleInpsStt('telefone', e.target.value)
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <SelectInput
              label='Gênero'
              value={inpsStt.genero}
              placeholder='Gênero'
              onChange={e => {
                actionsSettings.handleInpsStt('genero', e.target.value)
              }}
              options={[
                { value: 'Não informar', label: 'Não informar' },
                { value: 'Masculino', label: 'Masculino' },
                { value: 'Femenino', label: 'Feminino' },
                { value: 'Outro', label: 'Outro' },
              ]}
            />
          </Grid>
          <Grid item xs={6}>
            <InputText
              type='date'
              label='Data de Nascimento'
              placeholder='Data de Nascimento ex. 10/02/1995'
              autoComplete={'bday'}
              value={inpsStt.nascimento}
              onChange={e => {
                actionsSettings.handleInpsStt('nascimento', e.target.value)
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <ButtonLoading
              label='Salvar'
              loading={loadStt.newPass}
              disabled={actionsSettings.verificaAlteracoes()}
              onClick={() => {
                if (loadStt.newPass) return
                actionsSettings.SavedChangeUser()
              }}
            >
              Salvar Alterações
            </ButtonLoading>
          </Grid>
        </Grid>
      )}
    </>
  )
}
